import { QueryClient } from '@tanstack/react-query';

export function getContext() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        // 5 seconds to avoid immediate refetch on hydration
        staleTime: 1000 * 5,
        gcTime: 1000 * 60 * 5,
        retry: false,
      },
    },
  });

  return {
    queryClient,
  };
}
